/**
 * action type enum
 */
export enum ActionTypeEnum {
  EDIT = "EDIT",
  DELETE = "DELETE",
  ACTIVE_INACTIVE = "ACTIVE_INACTIVE",
  BLOCK = "BLOCk",
}
